import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Flex } from '../../../layout/Flex.mjs';
import { Typography } from '../../../typography/Typography.mjs';
import { controllerContainerInfoText, controllerContainer, controllerContainerActiveableText, controllerContainerClearButton } from '../../datePicker.vanilla.mjs';

function ControllerContainer({
  children,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      align: "center",
      justify: "between",
      className: classNames(controllerContainer, className),
      ...props,
      children
    }
  );
}
function ClearButton({ children, className, ...props }) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: classNames(controllerContainerClearButton, className),
      ...props,
      children: /* @__PURE__ */ jsx(Typography, { className: controllerContainerActiveableText, color: "gray", children })
    }
  );
}
const InfoText = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      Typography,
      {
        "data-scope": "date-picker",
        "data-part": "controller-container-info-text",
        ref,
        className: classNames(controllerContainerInfoText, className),
        ...props
      }
    );
  }
);
InfoText.toString = () => '[data-scope="date-picker"][data-part="controller-container-info-text"]';
ControllerContainer.InfoText = InfoText;
ControllerContainer.ClearButton = ClearButton;

export { ControllerContainer as default };
//# sourceMappingURL=ControllerContainer.mjs.map
